import { Component, OnInit, ViewChild, ComponentFactoryResolver, AfterContentInit } from '@angular/core';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { ModalContainerDirective } from '../ui-components/dynamic-modals/modal-container.directive';
import { EnUserTypes } from '../security/page-name.enum';

@Component({
    selector: 'app-generic-home-page',
    templateUrl: './generic-home-page.component.html',
    styleUrls: ['./generic-home-page.component.scss']
})

export class GenericHomePageComponent implements OnInit, AfterContentInit {

    @ViewChild(ModalContainerDirective, {static: true}) modalHostHomeDisplay: ModalContainerDirective;
    constructor(private authService: AuthServiceCustom,
        private componentFactoryResolver: ComponentFactoryResolver) { }

    ngOnInit() {

    }

    ngAfterContentInit() {
        let url = '';
        if (this.authService.UserType == EnUserTypes.Investor) {
            url = 'investorhome';
        } else if (this.authService.UserType == EnUserTypes.Rep) {
            url = 'rephome';
        } else if (this.authService.UserType == EnUserTypes.Broker) {
            url = 'brokerhome';
        } else if (this.authService.UserType == EnUserTypes.Custodian) {
            url = 'custodianhome';
        } else if (this.authService.UserType == EnUserTypes.User) {
            url = 'userhome';
        } else if (this.authService.UserType == EnUserTypes.DupMail) {
            url = 'otheruserhome';
        }
        // EnUserTypes.Territory
        if (url) {
            this.openPageInCustomModalHost(url);
        }
    }

    openPageInCustomModalHost(url) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.authService.getComponentTypeFromUrl(url));
        const viewContainerRef = this.modalHostHomeDisplay.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
    }
}
